import { RQ } from 'utils';

export default {
  activityInfo: async function (state) {
    let acIds = state.split('-');
    const res = await RQ.mall.get('/api/app/meituActivity/get/' + acIds[1]);
    if (res.code == 0) {
      if(res.data && res.data.activityId) {
        this.activityDto = res.data;
        console.log('activityInfo==>', this.activityInfo)
      }else {
        this.tips('活动不存在');
      }
    } else if(res.code == -10){
      localStorage.removeItem(acIds[0]);
      this.jumpMeituAuth(state);
    } else {
      this.tips(res.msg);
    }
  },
  jumpMeituAuth: async function (state){
    const route = {
      path: `/app/meitu/redirect`,
      query: {
        state: state
      }
    };
    this.$router.push(route);
  },
  jumpActivity: async function () {
    if(this.activityDto && this.activityDto.activityLink){
      window.location.href = this.activityDto.activityLink;
    }
  },
  jumpHome: async function () {
    if(this.activityDto && this.activityDto.homeLink){
      window.location.href = this.activityDto.homeLink;
    }
  },
  jumpPersona: async function () {
    if(this.activityDto && this.activityDto.personalLink){
      window.location.href = this.activityDto.personalLink;
    }
  },
  confirmOrder: async function () {
    G.member = JSON.parse(localStorage.getItem(G.enterprise) || '{}');
    G.enterprise = G.member.enterpriseNo;
    if (G.member && G.member.token) {
      let params = {
        goodsInfoId: this.goodsInfoId,
        goodsNum: this.buyNum,
        isPlatform: G.is_platform !== undefined ? G.is_platform : 0
      }
      const res = await RQ.mall.post('/api/app/order/confirmOrder', params, {jsonBody: true});
      if (res.code == 0) {
        // TODO 临时使用localStorage页面传值，后边需修改掉
        window.localStorage.setItem('settlement', JSON.stringify(res.data));
        this.$router.push({
          path: `/${G.enterprise}/cart/settlement`,
          query: {
            goodsInfoId: this.goodsInfoId,
            goodsNum: this.buyNum
          }
        });
      } else {
        this.tips(res.msg);
      }
    } else {
      this.showLogin = true;
      // TODO login
    }
  },
};



// WEBPACK FOOTER //
// ./src/module/app/meituActivity/action.js